import styled from 'styled-components/macro'
import { PasswordInput } from '../../../../../shared/components/password-input/PasswordInput'
import { getFontFamily } from 'styles/theme'

export const LoginFormBody = styled.form``

export const PasswordInputWrapper = styled(PasswordInput)`
  margin-top: 15px;
  margin-bottom: 5px;
`

export const ForgotPasswordButton = styled.div`
  background: none;
  border: none;
  font-size: 14px;
  letter-spacing: -0.075em;
  padding: 0;
  margin-bottom: 30px;
  text-decoration: underline;
  cursor: pointer;
  color: #000;
  text-align: start;
  width: max-content;

  &.no-margin {
    margin-bottom: 0px;
  }

  &:hover,
  &:focus,
  &:visited {
    color: inherit;
  }
`

export const LoginErrorContainer = styled.div`
  margin: 30px 0 40px;
  padding: 10px;
  color: #ff0000;
  border: 1px solid #ff0000;
`

export const LoginErrorText = styled.span`
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: -0.075em;
  color: #ff0000;
`

export const LoginFormFooter = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-top: 20px;
`

export const FooterFirstSection = styled.div`
  display: flex;
  flex-direction: row;
  align-items: baseline;
  font-weight: 400;
  font-size: 16px;
  letter-spacing: -0.075em;
  color: #000000;
  margin-top: 20px;
`

export const SignupLinkButton = styled.span`
  margin: 3px;
  color: #c00000;
  text-decoration: underline;
  cursor: pointer;
`
export const FooterSecondSection = styled.div`
  display: flex;
  flex-direction: row;
  align-items: baseline;
  font-weight: 400;
  font-size: 12px;
  letter-spacing: -0.075em;
  color: #000000;
  margin-top: 40px;
`

export const DivButton = styled.div<{
  type?: 'button' | 'click' | 'reset' | undefined
}>`
  font-family: inherit;
  width: 100%;
  font-weight: 500;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: -0.075em;
  background: ${({ type }) => (type === 'reset' ? 'none' : 'rgba(0, 0, 0, 1)')};
  color: ${({ theme, type }) =>
    type === 'reset' ? theme.colors.black : theme.colors.white};
  padding: 15px 0;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  text-align: center;

  &.disabled {
    font-family: ${({ theme }) => getFontFamily(theme)};
    background: #e1e1e1;
    cursor: default;
  }
`
